import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, spacing } from "@mui/system";

import {
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  CardContent,
  Checkbox,
  CircularProgress,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import {
  DisplaySettingsOutlined,
  CloudUpload as MuiCloudUpload,
  PermDataSettingSharp,
  SettingsApplications,
} from "@mui/icons-material";
import useAuth from "../../../hooks/useAuth";
import NotaFiscalConfigurationNFSE from "./configuracao";
import NotaFiscalDadosFiscais from "./dados-fiscais";
import NotaFiscalDadoAcessoNFSE from "./dados-acesso";
import CatalogList from "../../Catalog/list/catalog-list";
import NFSCatalogListComponent from "./nfs-catalog-service";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

const FormControl = styled(MuiFormControl)(spacing);

const TextField = styled(MuiTextField)(spacing);

const Button = styled(MuiButton)(spacing);

const CloudUpload = styled(MuiCloudUpload)(spacing);

const CenteredContent = styled.div`
  text-align: center;
`;

const BigAvatar = styled(Avatar)`
  width: 350px;
  height: 120px;
  margin: 0 auto ${(props) => props.theme.spacing(2)};
`;

function MenuNotaFiscal({ nfConfiguration, loadConfig }) {
  const [menuId, setMenuId] = React.useState("nfse");

  const [isDirtyData, setIsDirtyData] = React.useState(false);

  const handleMenu = (e) => {
    console.log(isDirtyData);
    if (isDirtyData === true) {
      if (window.confirm("Tem certeza de que deseja sair?")) {
        setMenuId(e);
        setIsDirtyData(false);
      }
    } else {
      setMenuId(e);
    }
  };

  return (
    <React.Fragment>
      <Grid container>
        <Grid item sm={12} md={4}>
          <BottomNavigation
            showLabels
            sx={{ marginLeft: 5 }}
            value={menuId}
            onChange={(event, newValue) => {
              handleMenu(newValue);
            }}
          >
            <BottomNavigationAction
              label="Catálogo de serviços"
              value={"nfse"}
              icon={<DisplaySettingsOutlined />}
            />
            <BottomNavigationAction
              label="Dados Fiscais"
              value={"dados-fiscais"}
              icon={<DisplaySettingsOutlined />}
            />
            <BottomNavigationAction
              label="Acesso"
              value={"dado-acesso"}
              icon={<DisplaySettingsOutlined />}
            />
            <BottomNavigationAction
              label="Configuração"
              value={"configuration"}
              icon={<DisplaySettingsOutlined />}
            />
          </BottomNavigation>
        </Grid>
      </Grid>
      <Divider my={2} />

      {menuId === "nfse" && nfConfiguration && (
        <NFSCatalogListComponent
          nfConfiguration={nfConfiguration}
          loadConfig={loadConfig}
          setIsDirtyData={setIsDirtyData}
        />
      )}

      {menuId === "dados-fiscais" && nfConfiguration && (
        <NotaFiscalDadosFiscais
          nfConfiguration={nfConfiguration}
          loadConfig={loadConfig}
          setIsDirtyData={setIsDirtyData}
        />
      )}
      {menuId === "dado-acesso" && nfConfiguration && (
        <NotaFiscalDadoAcessoNFSE
          nfConfiguration={nfConfiguration}
          loadConfig={loadConfig}
          setIsDirtyData={setIsDirtyData}
        />
      )}
      {menuId === "configuration" && nfConfiguration && (
        <NotaFiscalConfigurationNFSE
          nfConfiguration={nfConfiguration}
          loadConfig={loadConfig}
          setIsDirtyData={setIsDirtyData}
        />
      )}
    </React.Fragment>
  );
}

export default MenuNotaFiscal;
